import { render } from "./DashboardGT.vue?vue&type=template&id=73ffb615"
import script from "./DashboardGT.vue?vue&type=script&lang=js"
export * from "./DashboardGT.vue?vue&type=script&lang=js"

import "./DashboardGT.vue?vue&type=style&index=0&id=73ffb615&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__